import React from 'react';

import { enqueueSnackbar } from 'notistack';
import { observer } from 'mobx-react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import { EntityInbodyDataConfig } from '../../../../containers/EntityInbodyDataConfig/EntityInbodyDataConfig';
import { angularizeWithProviders } from '../../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';

type NgzEntityInbodyInfoTabProps = {
  entityId: number;
};

const NgzEntityInbodyInfoTab = observer(({ entityId }: NgzEntityInbodyInfoTabProps) => {
  const { isSuperAdmin, isInbodyAdmin } = loggedInUserDataStore;
  const canEditInbodyData = isSuperAdmin || isInbodyAdmin;

  const formId = 'entityInbodyDataConfigForm';

  const handleSuccessSubmit = () => {
    enqueueSnackbar('InBody Info has been successfully updated', { variant: 'success' });
  };

  return (
    <>
      <EntityInbodyDataConfig
        entityId={entityId}
        formId={formId}
        onSuccessSubmit={handleSuccessSubmit}
      />
      {canEditInbodyData && <YesNoBtnRow yesText="Save" formId={formId} />}
    </>
  );
});

angularizeWithProviders(NgzEntityInbodyInfoTab, 'ngzEntityInbodyInfoTab', {
  entityId: '<',
});

export { NgzEntityInbodyInfoTab };
